 <!-- Right Side for Notification Details -->
 <mat-card *ngIf="details" class="col-md-8 notification-details w-full  h-auto !border-none" style=" margin: 10vh 5vh 5vh 0vh; background: none !important;" appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        Notification Details
        <span *ngIf="details?.is_obsolete" class="text-red-500">(Obsolete)</span>
      </mat-card-title>
    </mat-card-header>
  
    <mat-card-content class="mt-[25px] rounded-md">
      <p ><strong>Subject:</strong><span [innerHTML]="parsedSelectedNotificationData?.subject"></span></p>
      <p><strong>Sent By:</strong> {{ details?.sender_email }}</p>
      <p><strong>Received By:</strong> {{ details?.receiver_email }}</p>
      <p><strong>Description:</strong> <span [innerHTML]="parsedSelectedNotificationData?.notes"></span></p>
      <p><strong>Date:</strong>  {{ details?.created_at | date : "yyyy-MM-dd" }}</p>
  </mat-card-content>
  </mat-card>